import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { initSentry } from '@weretradeit/sentry/react';
/* design-system v3 zuerst (Token UND Bauteilklassen; v3/base.css zieht die
   v2-Aliase selbst mit), dann die App. Hier stand
   '@weretradeit/ui-react/src/styles.css' — 4.2.1 liefert kein src/ und kein
   CSS mehr, die Zeile haette den Bau gebrochen.

   Die Szene `wt-glyphfield.testingOctopus.js` steht BEWUSST NICHT hier:
   App.tsx laedt sie nach dem Einhaengen im Leerlauf (glyphScene.ts). */
import '@weretradeit/design-system/v3/base.css';
import { ErrorBoundary } from "@weretradeit/ui-react";
import { App } from "./App";
import "./styles.css";

// Initialize Sentry error tracking
initSentry({ appName: 'testingOctopus' });

/* Die aeussere Fehlergrenze um die Wurzel: `appKey`, OHNE `fallback` (ein
   `fallback` gewaenne vor `appKey`) — ein Fehler in der Huelle selbst zeigt
   `GlyphErrorPage kind="500"` statt einer leeren Seite. */
ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <ErrorBoundary appKey="testingOctopus">
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
